import React, { ReactNode, FC } from "react";

import Box from "@mui/material/Box";

interface SompoContentBoxProps {
    children: ReactNode;
}

const SompoContentBox: FC<SompoContentBoxProps> = ({ children }) => <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: "7px" }}>{children}</Box>;

export default SompoContentBox;
